<template>
  <div class="list-box">
    <div class="nav gap-x-3" title="YongHuList" data-title="">
      <el-input
        v-model="state.params.keywords"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <el-button
        type="primary"
        icon="Plus"
        link
        @click="
          delete state.selectId;
          state.showAdd = true;
        "
      >
        添加
      </el-button>
    </div>
    <div class="content c-table-box mt-2">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column
          label="姓名"
          prop="admin_name"
          :formatter="$tab_TextFormat"
          :width="120"
        />
        <el-table-column
          label="所属部门"
          prop="add_department_name"
          :formatter="$tab_TextFormat"
          :width="120"
        />
        <el-table-column
          label="担任角色"
          prop="d_service_person_role_name"
          :formatter="$tab_TextFormat"
        />
        <el-table-column label="操作" fixed="right" align="center" :width="120">
          <template #default="{ row }">
            <el-button type="danger" :icon="Delete" link @click="onDelete(row)"
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showAdd"
    title="添加项目人员"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showAdd = false;
      }
    "
    append-to="#huiyi_detail"
    width="80%"
    style="height: 80%"
  >
    <c_add
      :meeting_id="props.meeting_id"
      :not_ids="state.not_ids"
      @close="
        state.showAdd = false;
        onLoad();
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  meeting_service_person_page,
  meeting_service_person_delete,
} from "@/http/meeting";
import { onDeleteConfirm } from "@/utils/funcs";

import c_add from "./Add.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    meeting_id: Number,
  },
  components: {
    c_add,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.meeting_id = props.meeting_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      meeting_service_person_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.tableData = list;
          state.totalCount = count;

          state.not_ids = list.map((m) => m.admin_id);
        }
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(meeting_service_person_delete, row.id, onLoad, {
        filed: "项目人员",
        name: row.admin_name,
      });
    };

    return { state, props, onLoad, onDelete };
  },
};
</script>

<style lang="scss" scoped></style>
